import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/sales/signups': {
    title: 'Sign-ups'
  },
  '/sales/cancellations': {
    title: 'Cancellations'
  },
  '/sales/cancellations/new': {
    title: 'New Cancellation',
    parentBreadcrumb: {
      label: 'Cancellations',
      href: (_params, orgSlug) => `/${orgSlug}/sales/cancellations`
    }
  },
  '/sales/cancellations/[id]': {
    title: 'Cancellation',
    parentBreadcrumb: {
      label: 'Cancellations',
      href: (_params, orgSlug) => `/${orgSlug}/sales/cancellations`
    }
  },
  '/sales/cancellations/recipients': {
    title: 'Notice recipients',
    parentBreadcrumb: {
      label: 'Cancellations',
      href: (_params, orgSlug) => `/${orgSlug}/sales/cancellations`
    }
  },
  '/sales/dashboard': {
    title: 'Dashboard'
  },
  '/sales/leads': {
    title: 'Leads'
  },
  '/sales/opportunities': {
    title: 'Opportunities'
  },
  '/sales/projects': {
    title: 'Projects'
  },
  '/sales/proposals': {
    title: 'Proposal Submissions'
  },
  '/sales/rankings': {
    title: 'Rankings'
  },
  '/sales/proposals/new': {
    title: 'New Proposal',
    parentBreadcrumb: {
      label: 'Proposal Submissions',
      href: (_params, orgSlug) => `/${orgSlug}/sales/proposals`
    }
  },
  '/sales/proposals/[id]': {
    title: 'Proposal',
    parentBreadcrumb: {
      label: 'Proposal Submissions',
      href: (_params, orgSlug) => `/${orgSlug}/sales/proposals`
    }
  },
  '/sales/opportunities/[opportunityId]': {
    // Full-bleed: the record manages its own scroll so the header
    // (title/actions/pipeline) stays pinned; page inset re-added locally.
    fullBleed: true,
    title: (params) => {
      const routeParams = params as { opportunityId?: string }
      const oppNumber = routeParams?.opportunityId
        ? decodeURIComponent(routeParams.opportunityId)
        : 'Opportunity'
      return `${oppNumber} • Summary`
    },
    tabKey: 'opportunity',
    parentBreadcrumb: {
      label: 'Opportunities',
      href: (_params, orgSlug) => `/${orgSlug}/sales/opportunities`
    }
  },
  '/sales/leads/[leadId]': {
    fullBleed: true,
    title: 'Lead • Summary',
    tabKey: 'lead',
    parentBreadcrumb: {
      label: 'Leads',
      href: (_params, orgSlug) => `/${orgSlug}/sales/leads`
    }
  },
  '/sales/carrier-quotes': {
    title: 'Carrier Quotes'
  },
  '/sales/carrier-quotes/[number]': {
    title: 'Carrier Quote',
    parentBreadcrumb: {
      label: 'Carrier Quotes',
      href: (_params, orgSlug) => `/${orgSlug}/sales/carrier-quotes`
    }
  },
  '/sales/dealhub-quotes': {
    title: 'Dealhub Quotes'
  },
  '/sales/dealhub-quotes/[id]': {
    title: 'Dealhub Quote',
    parentBreadcrumb: {
      label: 'Dealhub Quotes',
      href: (_params, orgSlug) => `/${orgSlug}/sales/dealhub-quotes`
    }
  },
  '/sales/site-surveys': {
    title: 'Site Surveys'
  },
  '/sales/site-surveys/new': {
    title: 'New Site Survey',
    parentBreadcrumb: {
      label: 'Site Surveys',
      href: (_params, orgSlug) => `/${orgSlug}/sales/site-surveys`
    }
  },
  '/sales/site-surveys/[id]': {
    title: 'Site Survey',
    parentBreadcrumb: {
      label: 'Site Surveys',
      href: (_params, orgSlug) => `/${orgSlug}/sales/site-surveys`
    }
  },
  '/sales/design-intake': {
    title: 'Design Intake'
  },
  '/sales/design-requests': {
    title: 'Design Requests'
  },
  '/sales/design-requests/new': {
    title: 'Request Design',
    parentBreadcrumb: {
      label: 'Design Requests',
      href: (_params, orgSlug) => `/${orgSlug}/sales/design-requests`
    }
  },
  '/sales/design-intake/send': {
    title: 'Send Intake',
    parentBreadcrumb: {
      label: 'Design Intake',
      href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake`
    }
  },
  '/sales/design-intake/[id]': {
    title: 'Submission',
    parentBreadcrumb: {
      label: 'Design Intake',
      href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake`
    }
  },
  '/sales/design-intake/templates': {
    title: 'Templates',
    parentBreadcrumb: {
      label: 'Design Intake',
      href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake`
    }
  },
  '/sales/design-intake/templates/new': {
    title: 'New Template',
    parentBreadcrumb: [
      {
        label: 'Design Intake',
        href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake`
      },
      {
        label: 'Templates',
        href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake/templates`
      }
    ]
  },
  '/sales/design-intake/templates/[id]': {
    title: 'Template',
    parentBreadcrumb: [
      {
        label: 'Design Intake',
        href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake`
      },
      {
        label: 'Templates',
        href: (_params, orgSlug) => `/${orgSlug}/sales/design-intake/templates`
      }
    ]
  }
}
